<template>
  <div>
    <div :class="$attrs.class">
      <div :class="headerSlotClass">
        <slot name="header" />
      </div>
      <div :class="mainSlotClass">
        <slot name="main" />
      </div>
      <div :class="footerSlotClass">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
    
    name: "Card",
    props: {
        headerSlotClass: {
            type: String,
            default: "",
        },
        mainSlotClass: {
            type: String,
            default: "",
        },
        footerSlotClass: {
            type: String,
            default: "",
        },
    },
}
</script>
<style scoped>
.card-progress {
    width: 562px;
    box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.06);
}

@media screen and (max-width:991px) {
    .card-progress {
        width: 100%;
    }
}
</style>

